import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const requestSchema = z.object({
	sessionUrl: z.string(),
});

const responseSchema = z.object({
	sessionData: z.string(),
});

const paymentAppleSession = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Payment/applesession',
		method: 'POST',
		requestSchema,
		responseSchema,
	});

export default paymentAppleSession;

export type PaymentAppleSessionResponse = TypeOfAPIResponse<ReturnType<typeof paymentAppleSession>>;

export type PaymentAppleSessionError = TypeOfAPIError<ReturnType<typeof paymentAppleSession>>;
